import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function LogoEmilamerica({ idVariant = '', className }: Props) {
  return (
    <IconBase name="logo-emilamerica" w={206} h={88} className={className}>
      <path
        d="M13.96 68.77L20.86 80.44H7.06L13.96 68.77ZM12.23 66.5L0.0200043 87.06H3.17L5.73001 82.72H22.19L24.75 87.06H27.9L15.69 66.5H12.23Z"
        fill="currentColor"
      />
      <path
        d="M62.07 66.5L50.06 83.73L38.05 66.5H33.7V87.05H36.49V68.99H36.54L49.07 87.05H51.05L63.58 68.99H63.63V87.05H66.42V66.5H62.07Z"
        fill="currentColor"
      />
      <path
        d="M75.99 66.5V87.05H96.29V84.78H78.77V77.6H95.5V75.33H78.77V68.77H96.18V66.5H75.99Z"
        fill="currentColor"
      />
      <path
        d="M122 76.66C125.1 76.66 126.4 75.84 126.4 73.68V71.8C126.4 69.5 125.41 68.76 121.32 68.76H108.66V76.66H122ZM105.87 66.5H122.31C128.24 66.5 129.18 68.46 129.18 72.32V74C129.18 76.89 127.53 77.69 125.4 77.89V77.95C128.24 78.46 128.92 79.94 128.92 81.81V87.06H126.31V82.55C126.31 79.34 124.75 78.94 122.22 78.94H108.65V87.06H105.87V66.5Z"
        fill="currentColor"
      />
      <path d="M139.84 66.5H137.06V87.06H139.84V66.5Z" fill="currentColor" />
      <path
        d="M147.71 73.9599C147.71 68.7599 149.47 66.2699 155.03 66.2699H165.68C170.74 66.2699 172.13 68.6299 172.13 71.3799V73.1399H169.69V72.1999C169.69 68.7099 167.53 68.5399 164.98 68.5399H155.32C152.65 68.5399 150.49 69.3299 150.49 72.9099V80.6299C150.49 84.2099 152.65 84.9999 155.32 84.9999H165.06C168.81 84.9999 169.89 84.2099 169.89 81.4199V80.1399H172.5V81.5299C172.5 85.2499 171.31 87.2699 165.54 87.2699H155.03C149.46 87.2699 147.71 84.7699 147.71 79.5699V73.9599Z"
        fill="currentColor"
      />
      <path
        d="M190.54 68.77L197.44 80.44H183.64L190.54 68.77ZM188.81 66.5L176.6 87.06H179.75L182.31 82.72H198.78L201.34 87.06H204.49L192.28 66.5H188.81Z"
        fill="currentColor"
      />
      <path
        d="M11.45 3.09C12.39 2.91 35.17 2.66 35.17 2.66L34.96 1.08C34.73 0.430002 34.2 0 33.28 0C32.52 0 0.74 0.01 0.0100002 0V6.62H0V51.42C0.73 51.4 32.51 51.42 33.28 51.42C34.2 51.42 34.73 50.99 34.96 50.34L35.17 48.75C35.17 48.75 12.39 48.49 11.45 48.32C9.08 47.88 7.17 46.45 7.09 42.7C7.09 41.28 6.94 25.92 6.94 25.92C8.15 25.92 13.43 25.92 17.01 26.28C19 26.5 19.84 27.58 20.3 29.09C20.53 29.88 21.36 30.13 21.75 30.05L23.43 29.83C23.74 29.76 23.88 29.62 23.88 29.25C23.73 27.74 23.43 27.35 23.43 24.83C23.43 23.75 23.43 20.92 23.66 19.69C23.74 19.4 23.59 19.12 23.2 19.12L21.3 19.05C20.99 19.05 20.39 19.29 20.15 20.01C19.46 22.24 18.85 22.81 16.64 23.18C15.72 23.32 7.56 23.61 6.95 23.61C6.95 23.61 7.1 9.38 7.1 8.7C7.17 4.96 9.08 3.53 11.45 3.09Z"
        fill="currentColor"
      />
      <path
        d="M102.55 0.210003C101.78 0.210003 100.94 0.280002 100.79 1.08C100.56 2.52 92.24 19.44 91.71 20.45C91.1 21.39 83.46 38.59 82.39 39.68L65.44 1.22C65.06 0.280001 64.6 0 63.46 0C62.54 0 60.56 0.210003 56.97 0.210003C56.35 0.210003 55.81 0.210001 55.32 0.200001V51.21C55.77 51.21 58.15 51.21 58.73 51.21C58.73 51.21 58.42 5.68 58.73 4.67C59.8 5.53 78.35 48.6 78.58 49.11C78.89 49.83 79.26 50.41 79.73 50.41C80.34 50.41 80.95 49.33 81.25 48.68C81.55 48.03 101.71 5.4 102.47 4.46H102.86C103.08 5.11 102.86 51.23 102.86 51.23C103.79 51.21 104.89 51.2 106.37 51.2C107.92 51.2 109.13 51.21 110.07 51.22L110.03 0.140003C108.58 0.180003 106.28 0.210003 102.55 0.210003Z"
        fill="currentColor"
      />
      <path
        d="M205.03 39.5099L203.81 39.0799C203.51 38.9299 203.35 39.0799 203.21 39.3699C202.14 42.1799 200.62 47.7599 196.12 48.3999C193.76 48.6899 178.64 48.5399 176.97 48.3999C177.01 45.5399 176.97 0.189941 176.97 0.189941C175.96 0.209941 170.04 0.209941 169.19 0.189941V51.1999C169.19 51.1999 202.54 51.2799 204.52 51.4199C204.97 49.4799 204.96 40.6699 205.19 40.1599C205.26 39.7199 205.26 39.6499 205.03 39.5099Z"
        fill="currentColor"
      />
      <path
        d="M135.82 0.189934V51.2299C136.81 51.2099 142.47 51.2099 143.42 51.2399L143.39 0.179932C142.48 0.199932 136.75 0.199934 135.82 0.189934Z"
        fill="currentColor"
      />
    </IconBase>
  )
}

export default LogoEmilamerica
